import { createSelector } from "reselect";
import { groupBy } from "../../../utils/groupBy";
import { RootState } from "../../rootReducer";

export const selectMessages = createSelector([(store: RootState) => store.users.messages], (data) =>
  groupBy(
    (data || []).map((item) => ({ ...item, createdAtDate: item.createdAtLegible?.date })),
    "createdAtDate"
  )
);
